import { MINCOL } from "../../../constants/const";

export const einwohnerHeader = [
    {accessor: 'id_zv',
    Header: 'ID Zweckverband',},
    {accessor: 'verband',
    Header: 'Zweckverband',
    width: '28em'},
    {accessor: 'jahr',
    Header: 'Jahr',
    width: MINCOL},
    {accessor: 'einwohner',
    Header: 'Anzahl Einwohner',
    width: '10em'},
]